<script setup lang="ts">
defineProps<{ searchTab: string }>();
</script>

<template>
    <div class="flex col column items-center">
        <div>
            <div class="flex justify-center q-my-xl">
                <i class="fa-thin fa-cloud-question icon-light-color fa-4x" />
            </div>
            <div class="title-semi-bold">
                {{ $t("shared.The search did not return any hits in “{tab}”", { tab: searchTab }) }}
            </div>

            <div class="q-mt-lg">
                <div class="title-semi-bold">{{ $t("shared.Possible causes") }}</div>
                <ul>
                    <li>{{ $t("shared.The search term is spelled incorrectly") }}</li>
                    <li>
                        {{
                            $t(
                                "shared.You havent selected the appropriate search context for example the wrong product"
                            )
                        }}
                    </li>
                    <li>{{ $t("shared.You dont have the permissions to see the relevant hits") }}</li>
                </ul>
            </div>
        </div>
    </div>
</template>
